import Model, { attr, belongsTo } from '@ember-data/model';
import { cached } from '@glimmer/tracking';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export enum BookingRentalAgreementStatus {
  pending = 'pending',
  processing = 'processing',
  processed = 'processed',
  markedAsSigned = 'marked_as_signed',
}

const SUCCESSFUL_STATUSES = [
  BookingRentalAgreementStatus.processing,
  BookingRentalAgreementStatus.processed,
  BookingRentalAgreementStatus.markedAsSigned,
];

export default class BookingRentalAgreementModel extends Model {
  @attr('string') fileLink!: string;
  @attr('string') status!: BookingRentalAgreementStatus;

  @belongsTo('booking', {
    inverse: 'bookingRentalAgreement',
    async: false,
  })
  booking!: ModelRegistry['booking'];

  @cached
  get isSigned(): boolean {
    return SUCCESSFUL_STATUSES.includes(this.status);
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'booking-rental-agreement': BookingRentalAgreementModel;
  }
}
